import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const ConfigDSCPProfilesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="DSCP Profiles"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
          DSCP Profiles. This profile matches all traffic marked with any of the listed DSCP code points.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>CODE POINT</b>: The DSCP code point. An integer between 0 and 63, both inclusive.
            </li>
            <li>
              <b>DIRECTION</b>: Traffic direction of the packet (downlink, uplink or any).
            </li>
            <li>
              <b>PRIORITY</b>: Evaluation priority in case of profile overlaps (more than one profile matches). Lower numbers evaluated first. (Number from -9999 to 9999).
            </li>
          </ul>
          <p>
            Press the <b>Add Profile...</b> option to add a new DSCP profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit an already configured profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete all entries of the corresponding profile.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Profile...</b> option to add a new
            profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">refresh</i>{" "}
            icon to refresh profiles information.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default ConfigDSCPProfilesHelpModal;
